import {
  actionCreator,
  checkHttpStatus,
  Claim_API,
  CLIENT_LOCK_ACTIVATION,
  GET_FILTER_PATIENT_API,
  createSearchUrl,
  GET_GUARDIAN_LIST_API,
  GET_GUARDIAN_DETAILS_API,
  POST_GUARDIAN_DETAILS_API,
  DELETE_GUARDIAN_DETAILS_API,
  POST_PATIENT_INSURANCE_API,
  GET_PATIENT_INSURANCE_API,
  GET_CUSTOMLABELS_API,
  POST_CUSTOMLABELS_API,
  createSearchUrlForCustomAPI,
  createSearchUrlWithoutPageNumberAndSize,
  DELETE_PATIENT_ADDRESS,
  DELETE_PATIENT_IMMUNIZATION_API,
  GET_PATIENT_DIAGNOSIS_API,
  POST_PATIENT_DIAGNOSIS_API,
  GET_PATIENT_DIAGNOSIS_DETAIL_API,
  DELETE_DIAGNOSIS_API,
  downloadFilesOnAPICallForCCDA,
  FILTER_PATIENT,
  GET_ALL_TAG,
  GET_CPT_API,
  GET_ICD_API,
  GET_MASTER_STATE_BY_COUNTRYID,
  GET_MASTERDATABYNAME,
  GET_PATIENT,
  POST_PATIENTDETAILS_API,
  GET_PATIENTDETAILS_API,
  POST_PATIENT_AUTHORIZATION,
  GET_PATIENT_AUTHORIZATION_LIST,
  GET_PATIENT_AUTHORIZATION_DETAILS,
  UPDATE_AUTHORIZATION_ACTIVE_STATUS,
  GET_PATIENT_BY_TAG,
  GET_PATIENT_IMMUNIZATION_API,
  GET_PATIENT_IMMUNIZATION_BYID_API,
  GET_PATIENT_PREFEFENCES,
  GET_PATIENT_PROFILE_DETAILS,
  GET_PATIENT_SOCIAL_HISTORY_API,
  POST_PATIENT_SOCIAL_HISTORY_API,
  GET_PAYER_SERVICE_CODES_API,
  IMPORT_PATIENT_CCDA,
  jsonApiHeader,
  PATIENT_ADDRESS_API,
  POST_PATIENT_ADDRESS_PHONE_DETAILS_API,
  GET_PATIENT_ADDRESS_PHONE_DETAILS_API,
  PATIENT_CUSTOM_API,
  PATIENT_DOCUMENT_DOWNLOAD, // patient document listing preview
  UPLOADED_DOCUMENT_DOWNLOAD, // uploaded document download
  DELETE_UPLOADED_DOCUMENT, // uploaded document delete
  PATIENT_ENCOUNTERS,
  PATIENT_ENCOUNTERS_DETAILS,
  POST_PATIENT_ENCOUNTERS_GENERATE_NARRATIVE_SUMMARY,
  NON_BILLABLE_ENCOUNTER_API,
  PATIENT_INSURANCE_API,
  PATIENT_INSURED_PERSON_API,
  PATIENT_LAB_ORDER,
  PATIENT_PAYERS_API,
  PATIENT_PAYERS_FOR_AUTHORIZATION_API,
  PATIENT_PHONE_API_POST_MULTIPLE,
  PATIENT_STATUS_ACTIVATION,
  PATIENT_TAG,
  patientActionTypes,
  PATIENTPORTAL_ACTIVATION,
  PAYER_ACTIVITY,
  POST_PATIENT_IMMUNIZATION_API,
  SAVE_SOAP_API,
  showErrorMessage,
  showSuccessMessage,
  SOAP_API,
  UPLOAD_PATIENT_DOCUMENTS_API,
  downloaduploadedDocumentsOnAPICall,
  GET_PATIENT_ALLERGIES_LIST,
  DELETE_PATIENT_ALLERGY,
  POST_PATIENT_ALLERGY,
  GET_PATIENT_ALLERGY_DETAILS,
  GET_PATIENT_VITALS_LIST,
  POST_PATIENT_VITAL,
  DELETE_PATIENT_VITAL,
  GET_PATIENT_VITAL_DETAILS,
  DELETE_PATIENT_AUTHORIZATION,
  GET_PATIENT_MEDICATION_DETAIL,
  POST_PATIENT_MEDICATION,
  GET_PATIENT_MEDICATION_LIST,
  DELETE_PATIENT_MEDICATION_DETAIL,
  GET_PATIENTLIST,
  POST_PATIENT_INTERNAL_NOTES_API,
  GET_PATIENT_INTERNAL_NOTES_API,
  DELETE_PATIENT_INTERNAL_NOTES_API,
  PREVIEW_DOCUMENT_DOWNLOAD,
  PreviewUploadedDocumentsOnAPICall,
  POST_USERDOCUMENT_MASTERFOLDER,
  GET_USERDOCUMENT_MASTERFOLDER,
  GET_USERDOCUMENT_MASTERFOLDERBYID,
  GET_USERDOCUMENT_SUBFOLDERBYID,
  POST_USERDOCUMENT_SUBFOLDER,
  GET_USERDOCUMENT_SUBFOLDER,
  MOVE_BATCHDOCUMENTS_INTO_FOLDER,
  INACTIVE_BATCHDOCUMENTS,
  DELETE_BATCHDOCUMENTS,
  ACTIVE_BATCHDOCUMENTS,
  DETELE_USERDOCUMENT_MASTERFOLDERBYID,
  DETELE_USERDOCUMENT_SUBFOLDERBYID,
  POST_UPLOADCLIENTLIST,
  GET_DOWNLOADSESSIONNOTESDOCUMENTS_API,
  PATIENT_STATUS_EXCLUDEFULLYPAID,
  GET_PATIENT_LOCATIONS_API,
  GET_AVAILABILITY_TEMPLATE,
  POST_AVAILABILITY_TEMPLATE_API,
  GET_AVAILABILITY_TEMPLATE_WITH_LOCATION,
  POST_AVAILABILITY_TEMPLATE_WITH_LOCATION_API
} from './../constants/ApiConstants';
import history from '../../../history';
import moment from 'moment';
import Alert from 'react-s-alert';
import GlobalVariables, { API_URL, checkHttpStatusAuthCheck, showWarningMessage } from '../../../actions/utilAction';

export const newPatient = () => {
  return (dispatch) => {
    dispatch(actionCreator(patientActionTypes.new_patient.SUCCESS));
  };
};

// export const getAppConfiguration = () => {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(patientActionTypes.get_appConfig.REQUEST));
//     fetch(`${GET_APPCONFIG}`, {
//       method: 'GET',
//       headers: jsonApiHeader(getState().login.access_token, 'application/json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         dispatch(actionCreator(patientActionTypes.get_appConfig.SUCCESS, response));
//       })
//       .catch(function(error) {
//         console.log('get_app configuration error..', error);
//       });
//   };
// };

export const getPatientMasterData = (masterData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_masterdata.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify(masterData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        // console.log('Master Data response: ', response);
        dispatch(actionCreator(patientActionTypes.get_patient_masterdata.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getPatientMasterData ..', error);
      });
  };
};

export const getMasterData = (masterDataList) => {
  return (dispatch, getState) => {
    // debugger;
    dispatch(actionCreator(patientActionTypes.get_masterdata.REQUEST));
    if (masterDataList === '' || masterDataList === undefined) {
      masterDataList = 'MASTERPHONEPREFERENCES,masterLocation,addresstype,frequencytype,masterCountry,masterEthnicity,maritalStatus,masterPreferredLanguage,masterRace,masterState,PatientStatus,Suffix,masterRelationship,masterprovider,masterProgram,masterService,phonetype,masterInsuranceCompany,masterReferral,insurancePlanType,mastericd,socialhistory,travelhistory,masterstaff,masterGender,masterPatientCommPreferences,MASTERVFC,MASTERIMMUNIZATION,MASTERMANUFACTURE,MASTERADMINISTRATIONSITE,mastercustomlabels,MASTERROUTEOFADMINISTRATION,MASTERIMMUNITYSTATUS,MASTERREJECTIONREASON,MASTERSTAFF,labtesttype,masterlonic,masterlabs,timetype,frequencytype,frequencydurationtype,MASTERALLERGIES,MASTERREACTION,MASTERSERVICECODE,authorizedprocedure,MASTERPATIENTLOCATION,appointmentType,MASTERTAGS,MASTERDOCUMENTTYPES';
    }

    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify({ 'masterdata': masterDataList }),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_masterdata.SUCCESS, response));
      })
      .catch(function(error) {

      });
  };
};

export const getMasterServiceCodeData = () => {
  return (dispatch, getState) => {
    // debugger;
    dispatch(actionCreator(patientActionTypes.get_masterdata.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify({ 'masterdata': 'MASTERSERVICECODE' }),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_masterdata.SUCCESS, response));
      })
      .catch(function(error) {

      });
  };
};

export const getPatientByTag = (searchObj) => { // Get Tag by name.
  return (dispatch, getState) => {
    // let query_params = createSearchUrl(searchObj);
    dispatch(actionCreator(patientActionTypes.get_patient_by_tag.REQUEST));
    // var bdy = JSON.stringify({ 'tag': `${searchData}`,'locationid': `${currentLocationId}` })
    // console.log('`${GET_PATIENT_BY_TAG}`...........',bdy);
    fetch(`${GET_PATIENT_BY_TAG}`, {
      method: 'post',
      // body: JSON.stringify({ 'tag': `${searchData}` }),
      body: JSON.stringify({ 'tag': `${searchObj.tag}`, 'locationid': `${searchObj.locationid}`, 'startwith': `${searchObj.startwith}`, 'isactive': `${searchObj.isactive}` }),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patient_by_tag.SUCCESS, response));
      })
      .catch(function(error) {

      });
  };
};

// Get all Tags.
export const getTagData = () => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_all_tag.REQUEST));
    fetch(`${GET_ALL_TAG}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('get_all_tag response: ', response);
        dispatch(actionCreator(patientActionTypes.get_all_tag.SUCCESS, response));
      })
      .catch(function(error) {

      });
  };
};

export const savePatientDetails = (formData) => {
  // console.log('formData...............',formData)
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patientDetails.REQUEST));
    fetch(POST_PATIENTDETAILS_API, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formData),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientDetails.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        dispatch(actionCreator(patientActionTypes.post_patientDetails.FAILURE, null));
        console.log('_savePatientDetails error', error);
      });
  };
};

// export const savePatient = (formData, diagnosisData) => {
//   const ICDID = formData.ICDID;
//   formData.FromDate = undefined;
//   formData.ToDate = undefined;
//   formData.FromDOB = undefined;
//   formData.ToDOB = undefined;
//   formData.StaffName = undefined;
//   formData.PatientInsurance = undefined;
//   formData.PatientNumber = undefined;
//   formData.Address = undefined;
//   // formData.IsBlock = null;
//   let postPreferenceData = [];
//   postPreferenceData.push({
//     /*
//             'PatientPreferenceID': parseInt(formData.PatientPreferenceID),
//             'PatientHomeCommPreferencesID': parseInt(formData.PatientHomeCommPreferencesID),
//             'PatientOfficeCommPreferencesID': parseInt(formData.PatientOfficeCommPreferencesID),*/
//     'ByEmail': formData.ByEmail,
//     'ByPhone': formData.ByPhone,
//     'OtherCommunication': formData.OtherCommunication,
//   });
//   /*
//       formData.PatientPreferenceID = undefined;
//       formData.PatientOfficeCommPreferencesID = undefined;
//       formData.PatientHomeCommPreferencesID = undefined;*/

//   return (dispatch, getState) => {
//     dispatch(actionCreator(patientActionTypes.post_patientdata.REQUEST));
//     let requestType = (formData.PatientID) ? 'PATCH' : 'post';
//     let fetchAPI = (formData.PatientID) ? `${GET_PATIENT}/${formData.PatientID}` : `${GET_PATIENT}`;

//     let saveData = JSON.stringify({
//       data: {
//         type: 'patients',
//         attributes: formData,
//       },
//     });
//     let updateData = JSON.stringify({
//       data: {
//         type: 'patients',
//         id: formData.PatientID,
//         attributes: formData,
//       },
//     });
//     let postData = (formData.PatientID) ? updateData : saveData;
//     // console.log(postData);
//     fetch(fetchAPI, {
//       method: requestType,
//       body: postData,
//       headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         // console.log(response);
//         if (response.meta.statusCode >= 200 && response.meta.statusCode < 300 && response.meta.statusCode !== 204) {
//           showSuccessMessage(response.meta.message);
//           dispatch(actionCreator(patientActionTypes.post_patientdata.SUCCESS, response));
//         } else {
//           showErrorMessage(response.meta.message);
//         }
//         if (response.statusCode !== undefined && response.statusCode === 404) {
//           showErrorMessage(response.message);
//         } else {
//           let patientID = response.data.id;
//           let diagnosisObject = {
//             'ICDID': ICDID,
//             'IsPrimary': true,
//             'IsActive': true,
//             'PatientID': patientID,
//           };
//           if (diagnosisData) {
//             diagnosisObject['PatientDiagnosisId'] = diagnosisData.PatientDiagnosisId;

//             dispatch(saveProblemData(diagnosisObject, diagnosisObject.PatientDiagnosisId, true));
//           }
//           if (diagnosisData === undefined) {
//             dispatch(saveProblemData(diagnosisObject, null, true));
//           }
//           postPreferenceData[0]['PatientID'] = parseInt(patientID, 10);
//           dispatch(__savePatientPreference(postPreferenceData[0]));
//           // let customSearchObj = {
//           //   filters: { TypeKey: 'ALL_CLIENT,BOTH' },
//           // };
//           // dispatch(getMasterCustomLabels(customSearchObj));
//           // dispatch(getPatientDetailsById(patientID));
//           // history.push(`/client/${patientID}`);
//           // console.log(patientID);
//           // let searchObj = {
//           //   filters: { patientid: patientID },
//           // };
//           // dispatch(getCustomAction(searchObj));
//         }
//       })
//       .catch(function(error) {
//         dispatch(actionCreator(patientActionTypes.post_patientdata.FAILURE));
//         console.log('error');

//       });
//   };
// };

export const __savePatientPreference = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patient_preference.REQUEST));

    let requestType = (formData.PatientPreferenceID) ? 'PATCH' : 'post';
    let fetchAPI = (formData.PatientPreferenceID) ? `${GET_PATIENT_PREFEFENCES}/${formData.PatientPreferenceID}` : `${GET_PATIENT_PREFEFENCES}`;
    let saveData = JSON.stringify({
      data: {
        type: 'patient-preference',
        attributes: formData,
      },
    });
    let updateData = JSON.stringify({
      data: {
        type: 'patient-preference',
        id: formData.PatientPreferenceID,
        attributes: formData,
      },
    });
    let postData = (formData.PatientPreferenceID) ? updateData : saveData;

    fetch(fetchAPI, {
      method: requestType,
      body: postData,
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.post_patient_preference.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

export const saveInsuranceDetails = (postData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patientInsuranceDetails.REQUEST));
    fetch(POST_PATIENT_INSURANCE_API, {
      method: 'post',
      body: JSON.stringify(postData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientInsuranceDetails.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientInsuranceDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error saveInsuranceDetails', error);
      });
  };
};

// export const saveInsurance = (formData, InsuredPerson) => {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(patientActionTypes.post_patient_insurance.REQUEST));
//     let requestType = (formData.InsuranceID) ? 'PATCH' : 'post';
//     let fetchAPI = (formData.InsuranceID) ? `${PATIENT_INSURANCE_API}/${formData.InsuranceID}` : `${PATIENT_INSURANCE_API}`;
//     let saveData = JSON.stringify({
//       data: {
//         type: 'patient-insurance-details',
//         attributes: formData,
//       },
//     });
//     let updateData = JSON.stringify({
//       data: {
//         type: 'patient-insurance-details',
//         id: formData.InsuranceID,
//         attributes: formData,
//       },
//     });
//     let postData = (formData.InsuranceID) ? updateData : saveData;
//     fetch(fetchAPI, {
//       method: requestType,
//       body: postData,
//       headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         // console.log('save insurance response', response);
//         if (!InsuredPerson.id && InsuredPerson.FirstName && !formData.PatientInsuranceID && (!formData.InsurancePersonSameAsPatient || formData.InsurancePersonSameAsPatient === null)) { // Create Insured after Insurance success.
//           InsuredPerson['PatientInsuranceID'] = response.data.attributes.PatientInsuranceID;
//           InsuredPerson['PatientID'] = formData.PatientID;
//           dispatch(saveInsuredPerson(InsuredPerson));
//         }
//         let insurances = [];
//         insurances.push(formData);
//         dispatch(actionCreator(patientActionTypes.post_patient_insurance.SUCCESS, response));
//         dispatch(actionCreator(patientActionTypes.get_patient_current_insurance.SUCCESS, response.data.attributes));
//         // console.log('response......', response);
//         if (response.meta.statusCode >= 200 && response.meta.statusCode < 300 && response.meta.statusCode !== 204) {
//           showSuccessMessage(response.meta.message);
//         } else {
//           showErrorMessage(response.meta.message);
//         }
//         // Alert.success(formData.InsuranceID ? 'Insurance has been updated successfully' : 'Insurance has been saved successfully', {
//         //   position: 'bottom-right',
//         //   effect: 'slide',
//         //   timeout: 2000,
//         // });
//       })
//       .catch(function(error) {
//         // errorHandler(error);
//         dispatch(actionCreator(patientActionTypes.post_patient_insurance.FAILURE));
//       });
//   };
// };

export const getPatientMedications = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientMedicationsList.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_PATIENT_MEDICATION_LIST}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patientMedicationsList.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patientMedicationsList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_patientMedicationsList', error);
      });

  };
};

export const getPatientMedicationDetails = (medicationId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientMedicationsDetails.REQUEST));
    fetch(`${GET_PATIENT_MEDICATION_DETAIL}?id=${medicationId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patientMedicationsDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patientMedicationsDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_patientMedicationsDetails', error);
      });

  };
};

export const savePatientMedication = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patientMedication.REQUEST));
    fetch(POST_PATIENT_MEDICATION, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientMedication.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientMedication.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_patientMedication', error);
      });
  };
};


export const deletePatientMedication = (medication_id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.delete_patientMedication.REQUEST));
    fetch(`${DELETE_PATIENT_MEDICATION_DETAIL}?id=${medication_id}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.delete_patientMedication.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.delete_patientMedication.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error delete_patientMedication', error);
      });
  };
};

export const saveInsuredPerson = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patient_insured_person.REQUEST));

    let requestType = (formData.InsuredPersonId) ? 'PATCH' : 'post';
    let fetchAPI = (formData.InsuredPersonId) ? `${PATIENT_INSURED_PERSON_API}/${formData.InsuredPersonId}` : `${PATIENT_INSURED_PERSON_API}`;
    let saveData = JSON.stringify({
      data: {
        type: 'insured-person',
        attributes: formData,
      },
    });
    let updateData = JSON.stringify({
      data: {
        type: 'insured-person',
        id: formData.InsuredPersonId,
        attributes: formData,
      },
    });
    let postData = (formData.InsuredPersonId) ? updateData : saveData;
    fetch(fetchAPI, {
      method: requestType,
      body: postData,
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('save insured person response--', response);
        let updatedData = response.data.attributes;
        updatedData['id'] = response.data.id;
        dispatch(actionCreator(patientActionTypes.post_patient_insured_person.SUCCESS, updatedData));
      })
      .catch(function(error) {
        // errorHandler(error);
        // dispatch(actionCreator(patientActionTypes.post_patient_insurance.FAILURE, response));
      });
  };
};

export const getPatientInsurancesDetails = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientInsuranceDetails.REQUEST));
    fetch(`${GET_PATIENT_INSURANCE_API}?patientId=${patientId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patientInsuranceDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patientInsuranceDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error getPatientInsurancesDetails', error);
      });
  };
};

// export const getPatientInsurance = (patientId) => {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(patientActionTypes.get_patient_insurance.REQUEST));
//     fetch(`${PATIENT_INSURANCE_API}?filter[PatientID]=${patientId}&include=insuredperson`, {
//       method: 'get',
//       headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         // let insurances = []; //  Filter Insurance by patientId
//         // response.data.filter((allData) => {
//         //   if (allData.type === 'patient-insurance-details') {
//         //     allData.attributes['id'] = allData.id;
//         //     insurances.push(allData.attributes);
//         //   }
//         // });

//         dispatch(actionCreator(patientActionTypes.get_patient_insurance.SUCCESS, response));
//       })
//       .catch(function(error) {
//         // errorHandler(error);
//       });
//   };
// };

export const getPatientInsuranceById = (patientId, key) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_insurance_byid.REQUEST));
    fetch(`${PATIENT_PAYERS_API}?PatientID=${patientId}&Key=${key}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patient_insurance_byid.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

export const getPatientInsuranceForAuthorizationById = (patientId, key ,date) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_insurance_byid.REQUEST));
    fetch(`${PATIENT_PAYERS_FOR_AUTHORIZATION_API}?PatientID=${patientId}&Key=${key}&StartDateTime=${date}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patient_insurance_byid.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

export const getPatientInsuredPerson = (patientInsuranceId) => {
  return (dispatch, getState) => {
    // console.log(patientInsuranceId);
    if (patientInsuranceId && patientInsuranceId !== null) {
      let query_params = '?include=insuredperson';
      fetch(`${PATIENT_INSURANCE_API}/${patientInsuranceId}${query_params}`, {
        method: 'get',
        headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.included) {
            let insuredPerson = response.included[0].attributes;
            insuredPerson['id'] = response.included[0].id;
            dispatch(actionCreator(patientActionTypes.get_patient_current_insured_person.SUCCESS, insuredPerson));
          }
          if (!response.included) {
            dispatch(actionCreator(patientActionTypes.get_patient_current_insured_person.SUCCESS, {}));
          }
        })
        .catch(function(error) {

        });
    } else {
      dispatch(actionCreator(patientActionTypes.get_patient_current_insured_person.SUCCESS, {}));
    }

  };
};

export const getPatientCurrentInsurance = (data) => {
  return (dispatch) => {
    dispatch(actionCreator(patientActionTypes.get_patient_current_insurance.SUCCESS, data));
  };
};

export const getPatientAddressPhoneDetails = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientAddressPhoneDetails.REQUEST));
    fetch(`${GET_PATIENT_ADDRESS_PHONE_DETAILS_API}?patientId=${patientId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patientAddressPhoneDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patientAddressPhoneDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_patientAddressPhoneDetails..', error);
      });
  };
};

export const savePatientAddressPhoneDetails = (postData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patientAddressPhoneDetails.REQUEST));
    fetch(POST_PATIENT_ADDRESS_PHONE_DETAILS_API, {
      method: 'post',
      body: JSON.stringify(postData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientAddressPhoneDetails.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientAddressPhoneDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error savePatientAddressPhoneDetails..', error);
      });
  };
};

// export const savePatientAddress = (formData) => {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(patientActionTypes.post_patient_address.REQUEST));
//     let requestType = (formData.AddressID) ? 'PATCH' : 'post';
//     let fetchAPI = (formData.AddressID) ? `${PATIENT_ADDRESS_API}/${formData.AddressID}` : `${PATIENT_ADDRESS_API}`;
//     let saveData = JSON.stringify({
//       data: {
//         type: 'patient-address',
//         attributes: formData,
//       },
//     });
//     let updateData = JSON.stringify({
//       data: {
//         type: 'patient-address',
//         id: formData.AddressID,
//         attributes: formData,
//       },
//     });
//     let postData = (formData.AddressID) ? updateData : saveData;
//     // console.log('postData  ---->', postData, requestType);
//     fetch(fetchAPI, {
//       method: requestType,
//       body: postData,
//       headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         // console.log(response);
//         // if (response.meta.statusCode >= 200 && response.meta.statusCode < 300 && response.meta.statusCode !== 204) {
//         //   showSuccessMessage(response.meta.message);
//         // } else {
//         //   showErrorMessage(response.meta.message);
//         // }
//         dispatch(actionCreator(patientActionTypes.post_patient_address.SUCCESS, { response: {}, message: response.meta.message }));
//         // console.log('response.meta.message .......',response.meta.message );

//         // dispatch(getPatientAddress(formData.PatientID));
//         dispatch(getPatientAddressById(formData.PatientID));
//         dispatch(getPatientPhoneById(formData.PatientID));
//         // dispatch(getPatientDetailsById(formData.PatientID));
//       })
//       .catch(function(error) {
//         // errorHandler(error);
//         dispatch(actionCreator(patientActionTypes.post_patient_address.SUCCESS, { response: {}, message: null }));
//       });
//   };
// };

export const savePatientPhone = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patient_address.REQUEST));
    let fetchAPI = (formData.PhoneID) ? `${PATIENT_PHONE_API_POST_MULTIPLE}` : `${PATIENT_PHONE_API_POST_MULTIPLE}`;
    let saveData = JSON.stringify(formData);
    let updateData = JSON.stringify(formData);
    let postData = (formData.PhoneID) ? updateData : saveData;
    // console.log('postData---', postData);
    fetch(fetchAPI, {
      method: 'post',
      body: postData,
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response--', response);
        // dispatch(actionCreator(patientActionTypes.post_patient_address.SUCCESS, { response: response, message: response.message }));
        // dispatch(getPatientAddressById(formData.PatientID));
        dispatch(getPatientPhoneById(formData.PatientID));
        dispatch(getPatientPreference(formData.PatientID));
        dispatch(getPatientDetailsById(formData.PatientID));
      })
      .catch(function(error) {
        // errorHandler(error);
        // dispatch(actionCreator(patientActionTypes.post_patient_address.SUCCESS, { response: {}, message: null }));
      });
  };
};
export const savePatientTag = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patient_tag.REQUEST));
    let fetchAPI = `${PATIENT_TAG}`;
    let data = JSON.stringify(formData);
    // console.log('data.........', data);
    fetch(fetchAPI, {
      method: 'post',
      body: data,
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.post_patient_tag.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

export const getPatientAddress = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_address.REQUEST));
    fetch(`${PATIENT_ADDRESS_API}?filter[PatientID]=${patientId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patient_address.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

// ?filter[PatientID]=175
export const getPatientPreference = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_preference.REQUEST));
    fetch(`${GET_PATIENT_PREFEFENCES}?filter[PatientID]=${patientId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patient_preference.SUCCESS, response[0]));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

export const getPatientData = () => {

  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientdata.REQUEST));
    fetch(`${GET_PATIENT}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patientdata.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

/**
 * [getPatientDetailsById get patient details by patient id]
 * @param  {[type]} patientId [description]
 * @return {[type]}           [description]
 */

export const getPatientDetailsById = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientDetailsById.REQUEST));
    fetch(`${GET_PATIENTDETAILS_API}?patientId=${patientId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patientDetailsById.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('getPatientDetailsById error ...', error);
      });
  };
};

export const getPatientProfileDetails = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_profileDetails.REQUEST));
    fetch(`${GET_PATIENT_PROFILE_DETAILS}?id=${patientId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patient_profileDetails.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('Client profile details error ', error);
      });
  };
};

// export const getPatientAddressById = (patientId) => {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(patientActionTypes.get_patientAddressById.REQUEST));
//     // console.log('`${GET_PATIENT}/${patientId}/?include=patientaddress` ..............',`${GET_PATIENT}/${patientId}/?include=patientaddress`)
//     fetch(`${GET_PATIENT}/${patientId}/?include=patientaddress`, {
//       method: 'get',
//       headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         // console.log('response getPatientAddressById: ', response);
//         let address = [];
//         if (response.included && response.included.length) { // Filter only Address.
//           response.included.map((allData, index) => {
//             if (allData.type === 'patient-address') {
//               allData.attributes['AddressID'] = allData.id;
//               address.push(allData.attributes);
//             }
//             return address;
//           });
//         }
//         dispatch(actionCreator(patientActionTypes.get_patientAddressById.SUCCESS, address));
//         // @get patient Preferences data with patient data
//       })
//       .catch(function(error) {
//         // errorHandler(error);
//         //   dispatch(actionCreator(patientActionTypes.get_patientById.FAILURE, error));
//       });
//   };
// };

export const getMasterStateByCountryId = (countryId) => {
  return (dispatch, getState) => {
    fetch(`${GET_MASTER_STATE_BY_COUNTRYID}/?countryID=${countryId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_master_state_by_countryid.SUCCESS, response.data));
      })
      .catch(function(error) {
        console.log('error: ', error);
      });
  };
};

export const getPatientPhoneById = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientPhoneById.REQUEST));
    fetch(`${GET_PATIENT}/${patientId}/?include=phonenumbers`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        let phone = [];
        if (response.included && response.included.length) { // Filter only Address.
          response.included.map((allData, index) => {
            if (allData.type === 'phone-numbers') {
              allData.attributes['PhoneID'] = allData.id;
              phone.push(allData.attributes);
            }
            return phone;
          });
        }
        // console.log('phone: ', phone);
        dispatch(actionCreator(patientActionTypes.get_patientPhoneById.SUCCESS, phone));
        // @get patient Preferences data with patient data
      })
      .catch(function(error) {
        // errorHandler(error);
        //   dispatch(actionCreator(patientActionTypes.get_patientById.FAILURE, error));
      });
  };
};

export const getPatientsByFilter = (filter, searchValue, advancedFilter, currentLocationId, tagSearch, viewTeamClientsOnlyPermission) => {
  return (dispatch, getState) => {
    if (!tagSearch) {
      dispatch(actionCreator(patientActionTypes.get_patient_ByFilter.REQUEST));
    } else {
      dispatch(actionCreator(patientActionTypes.get_patient_ByFilterWithTags.REQUEST));
    }
    fetch(`${GET_FILTER_PATIENT_API}?LocationIDs=${currentLocationId}&${filter}=${searchValue}${advancedFilter}&ViewTeamClientsOnly=${viewTeamClientsOnlyPermission}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          if (!tagSearch) {
            dispatch(actionCreator(patientActionTypes.get_patient_ByFilter.SUCCESS, response));
          } else {
            dispatch(actionCreator(patientActionTypes.get_patient_ByFilterWithTags.SUCCESS, response));
          }
        } else {
          if (!tagSearch) {
            dispatch(actionCreator(patientActionTypes.get_patient_ByFilter.SUCCESS, null));
          } else {
            dispatch(actionCreator(patientActionTypes.get_patient_ByFilterWithTags.SUCCESS, null));
          }
        }
      })
      .catch(function(error) {
        console.log('error patient by filter --', error);
      });
  };
};

export const getPatientsByFirstCharacter = (filter, searchValue, advancedFilter, currentLocationId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_ByALPHABET.REQUEST));
    let pageSize = 10;

    // if (searchValue === '' || searchValue === undefined) {
    //   pageSize = 26;
    // }

    // console.log('Main URL ...', `${FILTER_PATIENT}?page[size]=${pageSize}&filter[locationid]=${currentLocationId}&filter[${filter}]=${searchValue}${advancedFilter}`)
    fetch(`${FILTER_PATIENT}?page[size]=${pageSize}&filter[locationid]=${currentLocationId}&filter[${filter}]=${searchValue}${advancedFilter}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patient_ByALPHABET.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error client search --', error);
      });
  };
};

// get patient length 10.
export const getPatients = (filter, searchValue, selectedData) => {
  return (dispatch, getState) => {
    // dispatch(actionCreator(patientActionTypes.get_patients.REQUEST));
    fetch(`${GET_PATIENT}?page[size]=10&filter[${filter}]=${searchValue}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        /* if (selectedData && selectedData.length) {
          response.push(selectedData);
        }*/
        if (response.length) {
          dispatch(actionCreator(patientActionTypes.get_patients.SUCCESS, response));
        }
      })
      .catch(function(error) {
        console.log('error patient search --', error);
      });
  };
};

// get all patient.
export const getPatientsByLocation = (searchValue) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patients_by_location.REQUEST));
    fetch(`${GET_PATIENT}?filter[locationid]=${searchValue}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.length) {
          dispatch(actionCreator(patientActionTypes.get_all_patients.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_all_patients.SUCCESS, []));
        }
      })
      .catch(function(error) {
        console.log('error patient search --', error);
      });
  };
};

// get all patient.
export const getAllPatients = (filter, searchValue, selectedData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patients.REQUEST));
    fetch(`${GET_PATIENT}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.length) {
          dispatch(actionCreator(patientActionTypes.get_all_patients.SUCCESS, response));
        }
      })
      .catch(function(error) {
        console.log('error patient search --', error);
      });
  };
};

export const deletePatientAddress = (address_id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.delete_patient_address_action.REQUEST));
    fetch(`${DELETE_PATIENT_ADDRESS}/${address_id}`, {
      method: 'delete',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // let successMsg = 'Client-illness has been deleted successfully';
        // showSuccessMessage(successMsg);
        dispatch(actionCreator(patientActionTypes.delete_patient_address_action.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};


export const getMasterDiagnosisByName = (searchObj) => {
  let query_params = createSearchUrl(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_ICD_byName.REQUEST));
    fetch(`${GET_ICD_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_ICD_byName.SUCCESS, response));
      })
      .catch(function(error) {
        console.log(error);
      });
  };
};
export const getMasterCPTByName = (searchObj) => {
  let query_params = createSearchUrl(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_CPT_byName.REQUEST));
    fetch(`${GET_CPT_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_CPT_byName.SUCCESS, response));
      })
      .catch(function(error) {
        console.log(error);
      });
  };
};

export const saveProblemData = (postData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patientDiagnosis.REQUEST));
    fetch(`${POST_PATIENT_DIAGNOSIS_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(postData),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientDiagnosis.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientDiagnosis.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error saveProblemData', error);
      });
  };
};

// Action to fetch patient relations
// Puneet
//  20 Jul, 17
export const getPatientDiagnosisList = (searchObj) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientDiagnosisList.REQUEST));

    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_PATIENT_DIAGNOSIS_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patientDiagnosisList.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patientDiagnosisList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error getPatientDiagnosisList', error);
      });
  };
};

export const getPatientDiagnosisDetails = (diagnosisId) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientDiagnosisDetail.REQUEST));
    fetch(`${GET_PATIENT_DIAGNOSIS_DETAIL_API}?id=${diagnosisId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patientDiagnosisDetail.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patientDiagnosisDetail.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_patientDiagnosisDetail', error);
      });
  };
};

export const deleteDiagnosisData = (diagnosis_id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.delete_diagnosis_data.REQUEST));
    fetch(`${DELETE_DIAGNOSIS_API}?id=${diagnosis_id}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.delete_diagnosis_data.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.delete_diagnosis_data.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error deleteDiagnosisData', error);
      });
  };
};

export const getPatientImmunizationAction = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_immunization_action.REQUEST));
    let query_params = `?patientId=${searchObj.patientId}`; // createSearchUrl(searchObj);
    fetch(`${GET_PATIENT_IMMUNIZATION_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patient_immunization_action.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patient_immunization_action.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error getPatientImmunizationAction ...', error);
      });
  };
};

export const getPatientImmunizationDetailById = (immunizationId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_immunization_byId.REQUEST));
    let query_params = `?id=${immunizationId}`;
    fetch(`${GET_PATIENT_IMMUNIZATION_BYID_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patient_immunization_byId.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patient_immunization_byId.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error getPatientImmunizationDetailById ...', error);
      });
  };
};

export const savePatientImmunizationAction = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patient_immunization.REQUEST));
    fetch(POST_PATIENT_IMMUNIZATION_API, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patient_immunization.SUCCESS, response));
        } else if (response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patient_immunization.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patient_immunization.SUCCESS, null));
        }
      })
      .catch(function(error) {
        dispatch(actionCreator(patientActionTypes.post_patient_immunization.FAILURE));
        console.log('error savePatientImmunizationAction ...', error);
      });
  };
};

export const deletePatientImmunizationData = (immunizationId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.delete_patient_immunization_action.REQUEST));
    fetch(`${DELETE_PATIENT_IMMUNIZATION_API}?id=${immunizationId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.delete_patient_immunization_action.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.delete_patient_immunization_action.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error deletePatientImmunizationData ...', error);
      });
  };
};


// get patient's social history ...
export const getPatientSocialHistoryData = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientSocialHistoryByPatientId.REQUEST));
    fetch(`${GET_PATIENT_SOCIAL_HISTORY_API}?patientId=${patientId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patientSocialHistoryByPatientId.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patientSocialHistoryByPatientId.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error getPatientSocialHistoryData', error);
      });
  };
};

// save patient's social history ...
export const saveSocialHistory = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patient_social_history.REQUEST));
    fetch(POST_PATIENT_SOCIAL_HISTORY_API, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patient_social_history.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patient_social_history.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error saveSocialHistory', error);
      });
  };
};

// get patient lab orders
export const getPatientLabOrdersByID = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_labOrder.REQUEST));
    let query_params = createSearchUrl(searchObj);
    fetch(`${PATIENT_LAB_ORDER}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patient_labOrder.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};
// save patient lab order detail
export const savePatientLabOrder = (formData) => {
  let sendData = {
    PatientID: formData.PatientID,
    TestName: formData.TestName,
    TestTypeID: formData.TestTypeID,
    LonicCodeID: formData.LonicCodeID,
    ScheduledDate: formData.ScheduledDate,
    LabName: formData.LabName,
    OrderBy: parseInt(formData.OrderBy, 10) ? formData.OrderBy : null,
    OrderDate: formData.OrderDate,
    TestSpecimenSource: formData.TestSpecimenSource,
    ConditionOfSpecimen: formData.ConditionOfSpecimen,
    TimeTypeID: formData.TimeTypeID,
    FrequencyID: formData.FrequencyID,
    FrequencyDurationID: formData.FrequencyDurationID,
    Notes: formData.Notes,
    IsActive: true,
  };
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patient_LabOrder.REQUEST));
    let requestType = (formData.id) ? 'PATCH' : 'post';
    let fetchAPI = (formData.id) ? `${PATIENT_LAB_ORDER}/${formData.id}` : `${PATIENT_LAB_ORDER}`;

    let saveData = JSON.stringify({
      data: {
        type: 'patient-lab-test',
        attributes: sendData,
      },
    });

    let updateData = JSON.stringify({
      data: {
        type: 'patient-lab-test',
        id: formData.id,
        attributes: sendData,
      },
    });

    let postData = (formData.id) ? updateData : saveData;
    // console.log('requesttype:', requestType, 'postData:', postData, jsonApiHeader);

    fetch(fetchAPI, {
      method: requestType,
      body: postData,
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response save......', response);
        if (response.meta.statusCode >= 200 && response.meta.statusCode < 300 && response.meta.statusCode !== 204) {
          showSuccessMessage(response.meta.message);
          dispatch(actionCreator(patientActionTypes.post_patient_LabOrder.SUCCESS, response));
        } else {
          showErrorMessage(response.meta.message);
          dispatch(actionCreator(patientActionTypes.post_patient_LabOrder.FAILURE));
        }
      })
      .catch(function(error) {
        console.log('error-----', error);
      });
  };
};

// delete patient lab order detail
export const deletePatientLabOrderData = (order_id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.delete_patient_labOrder.REQUEST));
    fetch(`${PATIENT_LAB_ORDER}/DeleteAsync/${order_id}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode === 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.delete_patient_labOrder.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
        }
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

// get patient Encounters ...
export const getPatientEncountersById = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_encounters.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    // console.log('`${PATIENT_ENCOUNTERS}${query_params}`......',`${PATIENT_ENCOUNTERS}${query_params}`);
    fetch(`${PATIENT_ENCOUNTERS}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('Encounter response: ', response);
        dispatch(actionCreator(patientActionTypes.get_patient_encounters.SUCCESS, response));
      })
      .catch(function(error) {
        console.log(error);
      });
  };
};

export const generateNarrativeSummaryApi = (access_token, patientEncounterId) => {
  return fetch(`${POST_PATIENT_ENCOUNTERS_GENERATE_NARRATIVE_SUMMARY}?patientEncounterId=${patientEncounterId}`, {
    method: 'post',
    headers: jsonApiHeader(access_token, 'application/json'),
  }).then(checkHttpStatus);
};

export const generateNarrativeSummary = (patientEncounterId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patientEncountersGenerateNarrativeSummary.REQUEST));
    fetch(`${POST_PATIENT_ENCOUNTERS_GENERATE_NARRATIVE_SUMMARY}?patientEncounterId=${patientEncounterId}`, {
      method: 'post',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        console.log(response);
        dispatch(actionCreator(patientActionTypes.post_patientEncountersGenerateNarrativeSummary.SUCCESS, response.response));
      })
      .catch(function(error) {
        dispatch(actionCreator(patientActionTypes.post_patientEncountersGenerateNarrativeSummary.FAILURE, error.message));
      });
  };
};

// get patient Single Encounters Detail...
export const getPatientSingleEncounters = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_single_encounters.REQUEST));
    // let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${PATIENT_ENCOUNTERS_DETAILS}/${searchObj.apptId}/${searchObj.encounterId}?isAdmin=true`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response......',response);
        dispatch(actionCreator(patientActionTypes.get_patient_single_encounters.SUCCESS, response));
      })
      .catch(function(error) {
        console.log(error);
      });
  };
};

export const getNonBillableEncounterDetails = (appt_id, enc_id, isAdmin = false) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_nonBillableEncounterDetails.REQUEST));
    fetch(`${NON_BILLABLE_ENCOUNTER_API}/${appt_id}/${enc_id}?isAdmin=${isAdmin}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204)
          dispatch(actionCreator(patientActionTypes.get_nonBillableEncounterDetails.SUCCESS, response));
        else
          dispatch(actionCreator(patientActionTypes.get_nonBillableEncounterDetails.SUCCESS, null));
      })
      .catch(function(error) {
        console.log('get_nonBillableEncounterDetails error', error);
      });
  };
};

// get patient allergies ...
export const getPatientAllergiesList = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientAllergiesList.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_PATIENT_ALLERGIES_LIST}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204)
          dispatch(actionCreator(patientActionTypes.get_patientAllergiesList.SUCCESS, response));
        else
          dispatch(actionCreator(patientActionTypes.get_patientAllergiesList.SUCCESS, null));
      })
      .catch(function(error) {
        console.log('error getPatientAllergiesList', error);
      });
  };
};

// get patient allergy detail by id ...
export const getPatientAllergyDetail = (allergyId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientAllergyDetails.REQUEST));
    fetch(`${GET_PATIENT_ALLERGY_DETAILS}?id=${allergyId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204)
          dispatch(actionCreator(patientActionTypes.get_patientAllergyDetails.SUCCESS, response));
        else
          dispatch(actionCreator(patientActionTypes.get_patientAllergyDetails.SUCCESS, null));
      })
      .catch(function(error) {
        console.log('error get_patientAllergyDetails', error);
      });
  };
};

// save Client allergies ...
export const savePatientAllergy = (postData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patientAllergy.REQUEST));
    fetch(POST_PATIENT_ALLERGY, {
      method: 'POST',
      body: JSON.stringify(postData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientAllergy.SUCCESS, response));
        } else if (response.statusCode && response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientAllergy.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientAllergy.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_patientAllergy', error);
      });
  };
};

// delete patient allergy details ...
export const deletePatientAllergyDetails = (allergyId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.delete_patientAllergy.REQUEST));
    fetch(`${DELETE_PATIENT_ALLERGY}?id=${allergyId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.delete_patientAllergy.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.delete_patientAllergy.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error delete_patientAllergy', error);
      });
  };
};


// get service codes for the patient payer..
export const getPatientPayerServiceCodes = (searchObj) => {
  // let dateTime = null;
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_payer_service_codes.REQUEST));
    fetch(`${GET_PAYER_SERVICE_CODES_API}?patientId=${searchObj.patientId}&PayerPreference=${searchObj.payerPreference}&date=${searchObj.dateTime}&payerId=${searchObj.payerId}&patientInsuranceId=${searchObj.patientInsuranceId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patient_payer_service_codes.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patient_payer_service_codes.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };
};


// export const getPayerCptCodeByPayerId = (searchObj) => {
//   return (dispatch, getState) => {
//     // let query_params = `?filter[PayerId]=${payerId}&include=masterservicecode`;
//     dispatch(actionCreator(patientActionTypes.get_patient_payer_service_codes.REQUEST));
//     fetch(`${GET_PAYER_SERVICE_CODES_API}/${searchObj.patientId}/${searchObj.payerPreference}`, {
//       method: 'POST',
//       body: JSON.stringify(searchObj),
//       headers: jsonApiHeader(getState().login.access_token, 'application/json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         // console.log('response...........',response);
//         let serviceCodes = [];
//         response.filter((allData) => {
//           let obj = {
//             'id': allData.serviceCodeID,
//             'value': allData.cptCode,
//           };
//           serviceCodes.push(obj);
//         });
//         // console.log('serviceCodes.......',serviceCodes);
//         dispatch(actionCreator(patientActionTypes.get_patient_payer_service_codes.SUCCESS, serviceCodes));
//       })
//       .catch(function(error) {
//         // errorHandler(error);
//       });
//   };
// };

// save patient authorization details ...
// export const savePatientAuthorization = (formData) => {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(patientActionTypes.post_patient_authorization.REQUEST));
//     let requestType = (formData.authId) ? 'PATCH' : 'post';
//     let postApi = (formData.authId) ? `${PATIENT_AUTHORIZATION}/${formData.authId}` : `${PATIENT_AUTHORIZATION}`;

//     let saveData = JSON.stringify({
//       data: {
//         type: 'authorization',
//         attributes: formData,
//       },
//     });
//     let updateData = JSON.stringify({
//       data: {
//         type: 'authorization',
//         id: formData.authId,
//         attributes: formData,
//       },
//     });
//     let postData = (formData.authId) ? updateData : saveData;
//     // let contentType = (formData.authId) ? 'application/vnd.api+json' : 'application/json';
//     // console.log('///////----------', requestType, postData);
//     fetch(postApi, {
//       method: requestType,
//       body: postData,
//       headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         if (response) {
//           // console.log('authorization response..', response)

//           formData.AuthorizationId = response.data.id;
//           let authProcedures = {
//             AuthorizationID: formData.AuthorizationId,
//             AuthorizationProcedures: formData.AuthorizationProcedures.map((obj, i) => {
//               return {
//                 AuthorizationID: formData.AuthorizationId,
//                 ...obj,
//               };
//             }),
//           };
//           dispatch(savePatientAuthorizationProcedures(authProcedures));
//           // dispatch(actionCreator(patientActionTypes.post_patient_authorization.SUCCESS, response));
//         }
//       })
//       .catch(function(error) {
//         console.log(error);
//       });
//   };
// };

// // save patient authorization-procedure details ...
// export const savePatientAuthorizationProcedures = (formData) => {

//   return (dispatch, getState) => {
//     // dispatch(actionCreator(patientActionTypes.post_patient_authorization.REQUEST));
//     let requestType = 'PATCH';
//     let postApi = `${PATIENT_AUTHORIZATION_PROCEDURES}`;

//     let saveData = JSON.stringify(formData);
//     // console.log('///////----------', requestType, saveData);
//     fetch(postApi, {
//       method: requestType,
//       body: saveData,
//       headers: jsonApiHeader(getState().login.access_token, 'application/json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         if (response) {
//           dispatch(actionCreator(patientActionTypes.post_patient_authorization.SUCCESS, response));
//           if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
//             showSuccessMessage(response.message);
//           } else {
//             showErrorMessage(response.message);
//           }
//         }
//       })
//       .catch(function(error) {
//         console.log(error);
//       });
//   };
// };

// save patient authorization details ...
export const savePatientAuthorization = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patientAuthorization.REQUEST));
    fetch(POST_PATIENT_AUTHORIZATION, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientAuthorization.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientAuthorization.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_patientAuthorization', error);
      });
  };
};

// get patient authorization by patient id ...
export const getPatientAuthorizationByID = (patient_id) => {
  let patientId = patient_id
    , pageNumber = 1
    , pageSize = 100
    , authType = null;
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientAuthorizationList.REQUEST));
    fetch(`${GET_PATIENT_AUTHORIZATION_LIST}?patientId=${patientId}&pageNumber=${pageNumber}&pageSize=${pageSize}&authType=${authType}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patientAuthorizationList.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patientAuthorizationList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_patientAuthorizationList', error);
      });
  };
};

export const getPatientAuthorizationDetails = (authId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientAuthorizationDetails.REQUEST));
    fetch(`${GET_PATIENT_AUTHORIZATION_DETAILS}?authorizationId=${authId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patientAuthorizationDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patientAuthorizationDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_patientAuthorizationDetails', error);
      });
  };
};

// Update patient authorization status by authorizationID ...
export const UpdatePatientAuthorizationData = (authorizationId, IsRemoveFromDashboard) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.update_patientAuthorization_activeStatus.REQUEST));
    fetch(`${UPDATE_AUTHORIZATION_ACTIVE_STATUS}?authorizationId=${authorizationId}&IsRemoveFromDashboard=${IsRemoveFromDashboard}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode === 200 || response.statusCode === 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.update_patientAuthorization_activeStatus.SUCCESS, response));
        } else if (response.statusCode === 401) {
          showWarningMessage(response.message);
          dispatch(actionCreator(patientActionTypes.update_patientAuthorization_activeStatus.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.update_patientAuthorization_activeStatus.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error update_patientAuthorization_activeStatus', error);
      });
  };
};

// delete patient authorization details ...
export const deletePatientAuthorizationData = (authId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.delete_patientAuthorization.REQUEST));
    fetch(`${DELETE_PATIENT_AUTHORIZATION}?id=${authId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode === 200 || response.statusCode === 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.delete_patientAuthorization.SUCCESS, response));
        } else if (response.statusCode === 401) {
          showWarningMessage(response.message);
          dispatch(actionCreator(patientActionTypes.delete_patientAuthorization.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.delete_patientAuthorization.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error delete_patientAuthorization', error);
      });
  };
};

export const getPatientGuardianById = (guardianId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientGuardianDetails.REQUEST));
    fetch(`${GET_GUARDIAN_DETAILS_API}?id=${guardianId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patientGuardianDetails.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error get_patientGuardianDetails...', error);
      });
  };
};

export const getPatientGuardianList = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientGuardianList.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_GUARDIAN_LIST_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patientGuardianList.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getPatientGuardianList...', error);
      });
  };
};

export const postPatientGuardianDetails = (postData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patientGuardianDetails.REQUEST));
    fetch(`${POST_GUARDIAN_DETAILS_API}`, {
      method: 'post',
      body: JSON.stringify(postData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientGuardianDetails.SUCCESS, response));
        } else {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientGuardianDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_patientGuardianDetails...', error);
      });
  };
};

export const deletePatientGuardianDetails = (guardian_id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.delete_patientGuardianDetails.REQUEST));
    fetch(`${DELETE_GUARDIAN_DETAILS_API}?id=${guardian_id}`, {
      method: 'post',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response) {
          if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(patientActionTypes.delete_patientGuardianDetails.SUCCESS, response));
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(patientActionTypes.delete_patientGuardianDetails.SUCCESS, null));
          }
        }
      })
      .catch(function(error) {
        showErrorMessage('Oops, something went wrong, please try later');
        dispatch(actionCreator(patientActionTypes.delete_patientGuardianDetails.SUCCESS, null));
      });
  };
};

// export const getPatientGuardianAction = (searchObj) => {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(patientActionTypes.get_patient_guardian_action.REQUEST));
//     let query_params = createSearchUrl(searchObj);
//     fetch(`${PARENT_GUARDIAN_API}${query_params}`, {
//       method: 'get',
//       headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         // console.log(response);
//         dispatch(actionCreator(patientActionTypes.get_patient_guardian_action.SUCCESS, response));
//       })
//       .catch(function(error) {
//         // errorHandler(error);
//       });
//   };
// };

// export const postPatientGuardianAction = (formData) => {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(patientActionTypes.post_patient_guardian_action.REQUEST));
//     let idUrl = (formData.GuardianId) ? `/${formData.GuardianId}` : '';
//     let requestType = (formData.GuardianId ? 'PATCH' : 'post');
//     let fetchAPI = `${PARENT_GUARDIAN_API}/${idUrl}`;
//     let saveData = JSON.stringify({
//       data: {
//         type: 'patient-guardian',
//         attributes: formData,
//       },
//     });
//     let updateData = JSON.stringify({
//       data: {
//         type: 'patient-guardian',
//         id: formData.GuardianId,
//         attributes: formData,
//       },
//     });
//     let postData = (formData.GuardianId ? updateData : saveData);
//     // console.log('requeest type', requestType, 'post data', postData);
//     fetch(fetchAPI, {
//       method: requestType,
//       body: postData,
//       headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         // console.log(response);
//         if (response) {
//           if (response.statusCode >= 400 && response.statusCode < 500 && response.message) {
//             showErrorMessage(response.message);
//             dispatch(actionCreator(patientActionTypes.post_patient_guardian_action.SUCCESS, {}));
//           } else if (response.statusCode >= 200 && response.statusCode < 300) {
//             showSuccessMessage(response.message);
//             dispatch(actionCreator(patientActionTypes.post_patient_guardian_action.SUCCESS, response));
//           }
//         }
//       })
//       .catch(function(error) {
//         showErrorMessage(error);
//         dispatch(actionCreator(patientActionTypes.post_patient_guardian_action.SUCCESS, {}));
//         // console.log('-----f-ds-f-dsf-ds-f-ds-f-dfsdf-serror: ', error);
//       });
//   };
// };

// export const deletePatientGuardianAction = (guardian_id) => {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(patientActionTypes.delete_patient_guardian_action.REQUEST));
//     fetch(`${PARENT_GUARDIAN_API}/${guardian_id}`, {
//       method: 'delete',
//       headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         // console.log(response)
//         if (response) {
//           if (response.statusCode >= 400 && response.statusCode < 500 && response.message) {
//             showErrorMessage(response.message);
//             dispatch(actionCreator(patientActionTypes.delete_patient_guardian_action.SUCCESS, {}));
//           } else if (response.statusCode === 204) {
//             showSuccessMessage(response.message);
//             dispatch(actionCreator(patientActionTypes.delete_patient_guardian_action.SUCCESS, response));
//           }
//         }
//       })
//       .catch(function(error) {
//         showErrorMessage('Oops, something went wrong, please try later');
//         dispatch(actionCreator(patientActionTypes.delete_patient_guardian_action.SUCCESS, {}));
//       });
//   };
// };

export const getCustomAction = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_custom.REQUEST));

    let query_params = createSearchUrlWithoutPageNumberAndSize(searchObj);
    // console.log(`${PATIENT_CUSTOM_API}${query_params}`);
    fetch(`${PATIENT_CUSTOM_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('rr--------------', response);
        // debugger;
        dispatch(actionCreator(patientActionTypes.get_patient_custom.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

export const saveCustomLabelValues = (postData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_customLabelsValues.REQUEST));
    fetch(`${POST_CUSTOMLABELS_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(postData),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_customLabelsValues.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_customLabelsValues.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error----', error);
      });
  };
};

// export const saveCustomAction = (postData, patientId) => {
//   // console.log('attention here', postData, patientId);
//   let idUrl = (postData.id) ? `/${postData.id}` : '';
//   let fetchMethod = (postData.id) ? 'PATCH' : 'POST';

//   function jsonData() {
//     let JSONDATA = [];
//     postData.map((obj) => {
//       let item = {};
//       item['PatientID'] = patientId;
//       item['customLabelID'] = obj.customLabelID;
//       item['CustomLabelValue'] = obj.CustomLabelValue;
//       item['IsActive'] = obj.IsActive;
//       JSONDATA.push(item);
//       return JSONDATA;
//     });
//     // console.log('json data', JSONDATA);
//     return JSONDATA;
//   };
//   let jsonDataVariable = jsonData();
//   // console.log('jsonDataVariable', jsonDataVariable);
//   let formPostData = JSON.stringify({
//     PatientID: patientId,
//     PatientCustomLabels: jsonDataVariable,
//   });
//   // console.log('postdata', formPostData, fetchMethod);
//   return (dispatch, getState) => {
//     dispatch(actionCreator(patientActionTypes.post_patient_custom.REQUEST));
//     fetch(`${PATIENT_CUSTOM_API}/postMultiple${idUrl}`, {
//       method: fetchMethod,
//       headers: jsonApiHeader(getState().login.access_token, 'application/json'),
//       body: formPostData,
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         // console.log(response);
//         if (response) {
//           if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
//             showSuccessMessage(response.message);
//             dispatch(actionCreator(patientActionTypes.post_patient_custom.SUCCESS, response));
//           } else {
//             showErrorMessage(response.message);
//             dispatch(actionCreator(patientActionTypes.post_patient_custom.SUCCESS, {}));
//           }
//         }
//         let id = window.location.pathname.split('/').pop();
//         // console.log(id);
//         if (id !== 'client') {
//           let searchObj = {
//             filters: { patientid: id },
//           };
//           dispatch(getCustomAction(searchObj));
//         }
//       })
//       .catch(function(error) {
//         console.log('error----', error);
//         dispatch(actionCreator(patientActionTypes.post_patient_custom.SUCCESS, {}));
//         // errorHandler(error);
//       });
//   };
// };


// custom api's actions for patient vitals ...
export const getPatientVitalsList = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientVitalsList.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_PATIENT_VITALS_LIST}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patientVitalsList.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patientVitalsList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error getPatientVitalsList', error);
      });
  };
};

export const getPatientVitalDetails = (vitalId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientVitalDetails.REQUEST));
    fetch(`${GET_PATIENT_VITAL_DETAILS}?id=${vitalId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_patientVitalDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patientVitalDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_patientVitalDetails', error);
      });
  };
};

export const savePatientVitalDetails = (postData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patientVital.REQUEST));
    fetch(`${POST_PATIENT_VITAL}`, {
      method: 'POST',
      body: JSON.stringify(postData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientVital.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_patientVital.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_patientVital', error);
      });
  };
};

export const deleteVitalDetail = (vital_id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.delete_patientVital.REQUEST));
    fetch(`${DELETE_PATIENT_VITAL}?id=${vital_id}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.delete_patientVital.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.delete_patientVital.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error delete_patientVital', error);
      });
  };
};
// export const addFavouriteAction = (patientId, userID) => {
//   // console.log('in the favourite action');
//   return (dispatch, getState) => {
//     let formPostData = JSON.stringify({
//       data:
//         {
//           type: 'user-favourites',
//           attributes:
//             {
//               PatientID: patientId,
//               UserID: userID,
//               isDeleted: false,
//             },
//         },
//     });
//     // console.log(formPostData);
//     dispatch(actionCreator(patientActionTypes.post_favourite_action.REQUEST));
//     fetch(`${FAVOURITE_API}`, {
//       method: 'post',
//       body: formPostData,
//       headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         let successMsg = 'Favourite has been saved successfully';

//         showSuccessMessage(successMsg);
//         dispatch(actionCreator(patientActionTypes.post_favourite_action.SUCCESS, response));
//       })
//       .catch(function(error) {
//         console.log(error);
//       });
//   };
// };
// export const getFavourite = (searchObj) => {

//   return (dispatch, getState) => {
//     dispatch(actionCreator(patientActionTypes.get_favourite_action.REQUEST));
//     let query_params = createSearchUrl(searchObj);
//     // console.log(`${FAVOURITE_API}${query_params}`);
//     fetch(`${FAVOURITE_API}${query_params}`, {
//       method: 'get',
//       headers: jsonApiHeader(getState().login.access_token, 'application/json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {

//         dispatch(actionCreator(patientActionTypes.get_favourite_action.SUCCESS, response));
//         // console.log("patients:", response);
//       })
//       .catch(function(error) {
//         console.log('get_Favourite_Action');
//       });
//   };

// };
export const getSoapAction = (appt_id, enc_id) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_soap.REQUEST));
    // let query_params = createSearchUrl(searchObj);
    // console.log(`${SOAP_API}/${appt_id}/${enc_id}`);
    fetch(`${SOAP_API}/${appt_id}/${enc_id}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log(response);
        dispatch(actionCreator(patientActionTypes.get_patient_soap.SUCCESS, response));
      })
      .catch(function(error) {
        dispatch(actionCreator(patientActionTypes.get_patient_soap.FAILURE));
        console.log('get_patient_soap error', error);
      });
  };
};

export const createClaimAction = (enc_id) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.create_claim.REQUEST));
    // console.log(`${Claim_API}?patientEncounterId=${enc_id}`);
    fetch(`${Claim_API}?patientEncounterId=${enc_id}`, {
      method: 'post',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log(response);

        dispatch(actionCreator(patientActionTypes.create_claim.SUCCESS));
        let successMsg = response.message;
        showSuccessMessage(successMsg);
        // console.log(response);
      })
      .catch(function(error) {
        dispatch(actionCreator(patientActionTypes.create_claim.FAILURE));
        console.log('get_patient_soap--- create claim error', error);
      });
  };
};


export const savePatientSoapAction = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_patient_soap.REQUEST));
    let requestType = 'post';
    let fetchAPI = `${SAVE_SOAP_API}`;

    fetch(fetchAPI, {
      method: requestType,
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.post_patient_soap.SUCCESS, response));
        let successMsg = response.message;
        showSuccessMessage(successMsg);
        let enc_id = response.data.id;
        dispatch(getSoapAction(formData.PatientAppointmentId, enc_id));
      })
      .catch(function(error) {
        console.log('error-----', error);
      });
  };

};
// export const getMasterTags = (searchObj) => {

//   // let query_params = createSearchUrl(searchObj);
//   let query_params = createSearchUrlWithoutPageNumberAndSize(searchObj);
//   return (dispatch, getState) => {
//     // debugger;
//     // console.log(`${GET_MASTERTAGS}${query_params}`);
//     dispatch(actionCreator(patientActionTypes.get_master_tags.REQUEST));
//     fetch(`${GET_MASTERTAGS}${query_params}`, {
//       method: 'GET',
//       headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         // console.log('response-->', response);
//         dispatch(actionCreator(patientActionTypes.get_master_tags.SUCCESS, response));
//       })
//       .catch(function(error) {

//       });
//   };
// };

export const getPatientMasterTags = (masterDataList) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_master_tags.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify({ 'masterdata': masterDataList }),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patient_master_tags.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getPatientMasterTags', error);
      });
  };
};

export const getMasterCustomLabels = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_masterCustomLabels.REQUEST));
    fetch(`${GET_CUSTOMLABELS_API}?patientId=${patientId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_masterCustomLabels.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getMasterCustomLabels...', error);
      });
  };
};

// export const getMasterCustomLabels = (searchObj) => {
//   let query_params = createSearchUrlWithoutPageNumberAndSize(searchObj);
//   return (dispatch, getState) => {
//     dispatch(actionCreator(patientActionTypes.get_master_custom_labels.REQUEST));
//     // console.log(`${GET_MASTERCUSTOMLABELS}${query_params}`);
//     fetch(`${GET_MASTERCUSTOMLABELS}${query_params}`, {
//       method: 'GET',
//       headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         // console.log('response-->', response);
//         dispatch(actionCreator(patientActionTypes.get_master_custom_labels.SUCCESS, response));
//       })
//       .catch(function(error) {

//       });
//   };
// };

export const getPayerActivities = () => {
  return (dispatch, getState) => {
    let query_params = '?include=appointmenttype';
    dispatch(actionCreator(patientActionTypes.get_payer_activities.REQUEST));
    fetch(`${PAYER_ACTIVITY}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // let res = [];
        response.data.filter((data) => {
          response.included.filter((included) => {
            if (included.attributes.AppointmentTypeID === data.attributes.AppointmentTypeId) {
              data.attributes['AppointmentName'] = included.attributes.Name;
              data.attributes['value'] = included.attributes.Name;
            }
            return data;
          });
          return data;
        });
        dispatch(actionCreator(patientActionTypes.get_payer_activities.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

export const showPatientsSubMenus = (showStatus) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.patient_menu_show_status.SUCCESS, showStatus));
  };
};

export const UpdatePatientPortalActivation = (patientId, userId, IsPortalActivated) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.patch_patientportal_activation.REQUEST));

    fetch(`${PATIENTPORTAL_ACTIVATION}?patientID=${patientId}&userID=${userId}&isPortalActive=${IsPortalActivated}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response......',response);
        dispatch(actionCreator(patientActionTypes.patch_patientportal_activation.SUCCESS, response));
        dispatch(getPatientDetailsById(patientId));
        if (response && response.message) {
          showSuccessMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
        // dispatch(actionCreator(patientActionTypes.patch_patientportal_activation.FAILURE, response));
      })
      .catch(function(error) {
        console.log('error-----', error);
      });
  };

};
export const UpdatePatientActiveStatus = (patientId, IsActivate) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.patch_patient_active_status.REQUEST));
    // console.log('url',`${PATIENT_STATUS_ACTIVATION}/${patientId}/${IsActivate}`);
    fetch(`${PATIENT_STATUS_ACTIVATION}?patientID=${patientId}&isActive=${IsActivate}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response......',response);
        dispatch(actionCreator(patientActionTypes.patch_patient_active_status.SUCCESS, response));
        dispatch(getPatientDetailsById(patientId));
        if (response && response.message) {
          showSuccessMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
        // dispatch(actionCreator(patientActionTypes.patch_patient_active_status.FAILURE, response));
      })
      .catch(function(error) {
        console.log('error-----', error);
      });
  };

};

export const UpdateClientLockStatus = (UserID, IsBlock, patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.patch_client_lock_status.REQUEST));
    fetch(`${CLIENT_LOCK_ACTIVATION}/${UserID}/${IsBlock}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response) {
          if (response.statusCode >= 200 && response.statusCode < 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(patientActionTypes.patch_client_lock_status.SUCCESS, response));
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(patientActionTypes.patch_client_lock_status.SUCCESS, {}));
          }
          dispatch(getPatientDetailsById(patientId));
          history.push(`/client/profile/${patientId}`);
        }
      })
      .catch(function(error) {
        console.log('error-----', error);
        dispatch(actionCreator(patientActionTypes.patch_client_lock_status.SUCCESS, {}));
      });
  };

};

export const ImportPatientCCDA = (base64File) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.import_patient_ccda.REQUEST));
    fetch(`${IMPORT_PATIENT_CCDA}`, {
      method: 'post',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify({ 'file': base64File }),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.import_patient_ccda.SUCCESS, response));
        let successMsg = response.message; // formProps.id ? 'Payer activity has been updated successfully' : 'Payer activity has been saved successfully';
        if (response.statusCode === 500) {
          showErrorMessage(successMsg);
        } else {
          showSuccessMessage(successMsg);
        }
      })
      .catch(function(error) {
        console.log(error);
        dispatch(actionCreator(patientActionTypes.import_patient_ccda.FAILURE));
      });
  };
};

// Document Upload
export const saveDoucumentUpload = (uploadFileObj, UserID, ShowOnlyInactiveDocuments = false, ShowOnlyExpiredDocuments = false) => {
  // console.log('UserID-Action---', UserID);
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.upload_patient_documents.REQUEST));
    fetch(`${UPLOAD_PATIENT_DOCUMENTS_API}`, {
      method: 'post',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(uploadFileObj),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response-------', response);
        let searchObj = {          
          userId: UserID,
          fromDate: moment('1990-01-01').format('YYYY-MM-DD'),
          toDate: moment().format('YYYY-MM-DD'),
          documentTypeId: 0,
          showOnlyExpiredDocuments: ShowOnlyExpiredDocuments, 
          showOnlyInactiveDocuments: ShowOnlyInactiveDocuments,      
          masterFolderId : uploadFileObj.masterFolderId,
          subFolderId : uploadFileObj.subFolderId,
          searchText: '', 
        };
        dispatch(documentUploadDownload(searchObj));
        dispatch(actionCreator(patientActionTypes.upload_patient_documents.SUCCESS, response));
        // dispatch(getPatientDetailsById(patientId));
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
        } else if (response.statusCode === 422) {
          showWarningMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
      })
      .catch(function(error) {
        console.log('error-----', error);
      });
  };
};

// Document listing
export const documentUploadDownload = (searchObj) => {
  // console.log('userID---', UserID);
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patient_document_download.REQUEST));
    // fetch(`${PATIENT_DOCUMENT_DOWNLOAD}?userId=${searchObj.userId}&from=${searchObj.fromDate}&to=${searchObj.toDate}`, {
    fetch(`${PATIENT_DOCUMENT_DOWNLOAD}?userId=${searchObj.userId}&from=${searchObj.fromDate}&to=${searchObj.toDate}&documentTypeId=${searchObj.documentTypeId}&showOnlyExpiredDocuments=${searchObj.showOnlyExpiredDocuments}&showOnlyInactiveDocuments=${searchObj.showOnlyInactiveDocuments}&masterFolderId=${searchObj.masterFolderId}&subFolderId=${searchObj.subFolderId}&searchText=${searchObj.searchText}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(patientActionTypes.get_patient_document_download.SUCCESS, response.data));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

// Document Download
export const uploadedDocumentDownload = (docId, fileName,oldFolderName) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.uploaded_document_download.REQUEST));
    fetch(`${UPLOADED_DOCUMENT_DOWNLOAD}?id=${docId}&oldFolderName=${oldFolderName}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    }).then(function(response) {
      dispatch(actionCreator(patientActionTypes.uploaded_document_download.SUCCESS));
      return response.blob();
    }).then(function(blob) {
      downloaduploadedDocumentsOnAPICall(blob, fileName);
    });
  };
};

// Document Download
export const PreviewDownloadedDocument = (docId, fileName) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.preview_document_download.REQUEST));
    fetch(`${PREVIEW_DOCUMENT_DOWNLOAD}?id=${docId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    }).then(function(response) {
      dispatch(actionCreator(patientActionTypes.preview_document_download.SUCCESS));
      return response.blob();
    }).then(function(blob) {
      PreviewUploadedDocumentsOnAPICall(blob, fileName);
    });
  };
};

// Document Delete
export const deleteUploadedDocument = (docId, UserID,oldFolderName) => {
  // console.log('userId--', UserID);
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.delete_Uploaded_Document.REQUEST));
    fetch(`${DELETE_UPLOADED_DOCUMENT}?id=${docId}&oldFolderName=${oldFolderName}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response----', response);
        if (response.statusCode === 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.delete_Uploaded_Document.SUCCESS, response));
          let searchObj = {
            userId: UserID,
            fromDate: moment('1990-01-01').format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD'),
          };
          dispatch(documentUploadDownload(searchObj));
        } else {
          showErrorMessage(response.message);
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };
};

export const ExportCCDA = (patientID) => {
  return (dispatch, getState) => {
    // window.open(`${API_URL}/patient/GetPatientCCDA/${patientID}`, '_blank');

    let apiURL = `${API_URL}/patients/GetPatientCCDA?id=${patientID}`;
    fetch(apiURL, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/xml'),
    })
      .then((r) => r.blob())
      .then(downloadFilesOnAPICallForCCDA) // showPDF
      .then();
  };
};

export const getPatientsList = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_PatientsList.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);

    fetch(`${GET_PATIENTLIST}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_PatientsList.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_PatientsList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('get_PatientsList...', error);
      });

  };
};



// save Update Patient Internal Notes
export const savePatientInternalNote = (formData, patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.Post_Patient_Internal_Notes.REQUEST));
    let apiURL = `${POST_PATIENT_INTERNAL_NOTES_API}`;
    fetch(`${apiURL}`, {
      method: 'POST',      
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formData)
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response) {
          dispatch(actionCreator(patientActionTypes.Post_Patient_Internal_Notes.SUCCESS, response));
          // console.log('response.......',response)
          if (response && response.message){
            showSuccessMessage(response.message);            
            let searchObj = {
                sort_fields: '',
                sort_order:  '',
                contain_filters: { patientId: patientId, SearchText: null },
                pageNumber: 1,
            };      
            dispatch(getAllPatientInternalNotes(searchObj, patientId));            
          }
          else
            showSuccessMessage('Patient notes has been updated successfully');       
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const getAllPatientInternalNotes = (searchObj, patientId) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);  
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.Get_Patient_Internal_Notes.REQUEST));
    fetch(`${GET_PATIENT_INTERNAL_NOTES_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response.................', response)
        dispatch(actionCreator(patientActionTypes.Get_Patient_Internal_Notes.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};

export const deletePatientInternalNote = (noteId, patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.Delete_Patient_Internal_Notes.REQUEST));
    let apiURL = `${DELETE_PATIENT_INTERNAL_NOTES_API}?noteId=${noteId}`;
    fetch(`${apiURL}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response) {
          if (response && response.statusCode == 200){
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.Delete_Patient_Internal_Notes.SUCCESS, response));
            let searchObj = {
              sort_fields: '',
              sort_order:  '',
              contain_filters: { patientId: patientId, SearchText: null },
              pageNumber: 1,
          };      
          dispatch(getAllPatientInternalNotes(searchObj, patientId));
          }
          else{
            showSuccessMessage(response.message);
            dispatch(actionCreator(patientActionTypes.Delete_Patient_Internal_Notes.SUCCESS, null));
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};


export const getUserDocumentMasterFolderList = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.Get_UserDocumentMasterFolder.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_USERDOCUMENT_MASTERFOLDER}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(  patientActionTypes.Get_UserDocumentMasterFolder.SUCCESS, response));
        } else {
          dispatch(actionCreator(  patientActionTypes.Get_UserDocumentMasterFolder.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error Get_UserDocumentMasterFolder ', error);
      });
  };
};

export const deleteUserDocumentMasterFolder = (masterFolderId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.Delete_UserDocumentMasterFolderById.REQUEST));
    let apiURL = `${DETELE_USERDOCUMENT_MASTERFOLDERBYID}?masterFolderId=${masterFolderId}`;
    fetch(`${apiURL}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response) {
          if (response && response.statusCode == 200){
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.Delete_UserDocumentMasterFolderById.SUCCESS, response));          
          }
          else{
            showErrorMessage(response.message);
            dispatch(actionCreator(patientActionTypes.Delete_UserDocumentMasterFolderById.SUCCESS, null));
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const deleteUserDocumentSubFolder = (subFolderId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.Delete_UserDocumentSubFolderById.REQUEST));
    let apiURL = `${DETELE_USERDOCUMENT_SUBFOLDERBYID}?subFolderId=${subFolderId}`;
    fetch(`${apiURL}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response) {
          if (response && response.statusCode == 200){
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.Delete_UserDocumentSubFolderById.SUCCESS, response));          
          }
          else{
            showErrorMessage(response.message);
            dispatch(actionCreator(patientActionTypes.Delete_UserDocumentSubFolderById.SUCCESS, null));
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};


export const saveUserDocumentMasterFolder = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.Post_UserDocumentMasterFolder.REQUEST));
    fetch(POST_USERDOCUMENT_MASTERFOLDER, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.Post_UserDocumentMasterFolder.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.Post_UserDocumentMasterFolder.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error Post_UserDocumentMasterFolder', error);
      });
  };
};


export const GetUserDocumentMasterFolderById = (masterFolderId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.Get_UserDocumentMasterFolderById.REQUEST));
    fetch(`${GET_USERDOCUMENT_MASTERFOLDERBYID}?masterFolderId=${masterFolderId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.Get_UserDocumentMasterFolderById.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.Get_UserDocumentMasterFolderById.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error Get_UserDocumentMasterFolderById ', error);
      });
  };
};





export const getUserDocumentSubFolderList = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.Get_UserDocumentSubFolder.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_USERDOCUMENT_SUBFOLDER}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(  patientActionTypes.Get_UserDocumentSubFolder.SUCCESS, response));
        } else {
          dispatch(actionCreator(  patientActionTypes.Get_UserDocumentSubFolder.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error Get_UserDocumentSubFolder ', error);
      });
  };
};


export const saveUserDocumentSubFolder = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.Post_UserDocumentSubFolder.REQUEST));
    fetch(POST_USERDOCUMENT_SUBFOLDER, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.Post_UserDocumentSubFolder.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.Post_UserDocumentSubFolder.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error Post_UserDocumentSubFolder', error);
      });
  };
};


export const GetUserDocumentSubFolderById = (subFolderId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.Get_UserDocumentSubFolderById.REQUEST));
    fetch(`${GET_USERDOCUMENT_SUBFOLDERBYID}?subFolderId=${subFolderId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.Get_UserDocumentSubFolderById.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.Get_UserDocumentSubFolderById.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error Get_UserDocumentSubFolderById ', error);
      });
  };
};


export const MoveBatchDocumentsIntoFolder = (documentIds, masterFolderId, subFolderId, folderType) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_MoveBatchDocumentsIntoFolder.REQUEST));
    fetch(`${MOVE_BATCHDOCUMENTS_INTO_FOLDER}?documentIds=${documentIds}&masterFolderId=${masterFolderId}&subFolderId=${subFolderId}&oldFolderName=${folderType}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_MoveBatchDocumentsIntoFolder.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_MoveBatchDocumentsIntoFolder.SUCCESS, null));          
        }
      })
      .catch(function (error) {
        console.log('error post_MoveBatchDocumentsIntoFolder', error);
      });
  };
};

export const BatchInactiveDocuments = (documentIds,folderType) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_InactiveBatchDocuments.REQUEST));
    fetch(`${INACTIVE_BATCHDOCUMENTS}?documentIds=${documentIds}&oldFolderName=${folderType}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_InactiveBatchDocuments.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_InactiveBatchDocuments.SUCCESS, null));          
        }
      })
      .catch(function (error) {
        console.log('error post_InactiveBatchDocuments', error);
      });
  };
};


export const BatchActiveDocuments = (documentIds,folderType) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_InactiveBatchDocuments.REQUEST));
    fetch(`${ACTIVE_BATCHDOCUMENTS}?documentIds=${documentIds}&oldFolderName=${folderType}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_InactiveBatchDocuments.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_InactiveBatchDocuments.SUCCESS, null));          
        }
      })
      .catch(function (error) {
        console.log('error post_InactiveBatchDocuments', error);
      });
  };
};

export const BatchDeleteDocuments = (documentIds,folderType) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_DeleteBatchDocuments.REQUEST));
    fetch(`${DELETE_BATCHDOCUMENTS}?documentIds=${documentIds}&oldFolderName=${folderType}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_DeleteBatchDocuments.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.post_DeleteBatchDocuments.SUCCESS, null));          
        }
      })
      .catch(function (error) {
        console.log('error post_DeleteBatchDocuments', error);
      });
  };
};


// Document Upload
export const UploadClientListFile = (UploadFile) => {
   console.log('JSON.stringify(UploadFile)-Action---', JSON.stringify(UploadFile));
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.post_UploadClientList.REQUEST));
    fetch(`${POST_UPLOADCLIENTLIST}`, {
      method: 'post',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(UploadFile),
    })
      .then(checkHttpStatus)
      .then(function(response) {        
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
        } else if (response.statusCode === 422) {
          showWarningMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
      })
      .catch(function(error) {
        console.log('error-----', error);
      });
  };
};


// Document Download
export const downloadSessionNotesDocuments = (patientAppointmentIds, fileName, searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_DownloadSessionNotesDocuments.REQUEST));
    fetch(`${GET_DOWNLOADSESSIONNOTESDOCUMENTS_API}?patientAppointmentIds=${patientAppointmentIds}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    }).then(function(response) {
      // console.log('response-------', response);      
      dispatch(getPatientEncountersById(searchObj));
      dispatch(actionCreator(patientActionTypes.get_DownloadSessionNotesDocuments.SUCCESS));
      return response.blob();
    }).then(function(blob) {     
      downloaduploadedDocumentsOnAPICall(blob, fileName);
    });
  };
};

export const UpdatePatientExcludeFullyPaidStatus = (patientId, isExcludeFullyPaid) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.patch_patient_excludefullypiad_status.REQUEST));
    // console.log('url',`${PATIENT_STATUS_ACTIVATION}/${patientId}/${IsActivate}`);
    fetch(`${PATIENT_STATUS_EXCLUDEFULLYPAID}?patientID=${patientId}&isExcludeFullyPaid=${isExcludeFullyPaid}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response......',response);
        dispatch(actionCreator(patientActionTypes.patch_patient_excludefullypiad_status.SUCCESS, response));
        dispatch(getPatientDetailsById(patientId));
        if (response && response.message) {
          showSuccessMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
        // dispatch(actionCreator(patientActionTypes.patch_patient_excludefullypiad_status.FAILURE, response));
      })
      .catch(function(error) {
        console.log('error-----', error);
      });
  };

};

export const getPatientLocationsById = (staffId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.get_patientLocations.REQUEST));
    fetch(`${GET_PATIENT_LOCATIONS_API}?Id=${staffId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 300) {
          dispatch(actionCreator(patientActionTypes.get_patientLocations.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_patientLocations.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error get_staffLocations...', error);
      });
  };
};

export const getAvailabilityTemplateByClientID_withLocation = (patientId, locationId) => {
  return (dispatch, getState) => {

    dispatch(actionCreator(patientActionTypes.get_availability_template_by_id.REQUEST));
    let url = `${GET_AVAILABILITY_TEMPLATE_WITH_LOCATION}?patientID=${patientId}&locationId=${locationId}`;
    fetch(url, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_availability_template_by_id.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_availability_template_by_id.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error getAvailabilityTemplateByClientID_withLocation', error);
      });
  };
};

export const saveAvailabilityTemplate_withLocation = (formProps) => {
  let postData = JSON.stringify(formProps);
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.save_availability_template.REQUEST));
    fetch(`${POST_AVAILABILITY_TEMPLATE_WITH_LOCATION_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: postData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          Alert.closeAll();
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.save_availability_template.SUCCESS, response));
        } else {
          Alert.closeAll();
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.save_availability_template.FAILURE));
        }
      })
      .catch(function(error) {
        console.log('error saveAvailabilityTemplate_withLocation', error);
        dispatch(actionCreator(patientActionTypes.save_availability_template.FAILURE));
      });
  };
};

export const getAvailabilityTemplateByStaffID = (staffId) => {
  return (dispatch, getState) => {

    dispatch(actionCreator(patientActionTypes.get_availability_template_by_id.REQUEST));
    let url = `${GET_AVAILABILITY_TEMPLATE}/${staffId}/false`;
    fetch(url, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(patientActionTypes.get_availability_template_by_id.SUCCESS, response));
        } else {
          dispatch(actionCreator(patientActionTypes.get_availability_template_by_id.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error get_availability_template_by_id', error);
      });
  };
};

export const saveAvailabilityTemplate = (formProps) => {
  let postData = JSON.stringify(formProps);
  return (dispatch, getState) => {
    dispatch(actionCreator(patientActionTypes.save_availability_template.REQUEST));
    fetch(`${POST_AVAILABILITY_TEMPLATE_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: postData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          Alert.closeAll();
          showSuccessMessage(response.message);
          dispatch(actionCreator(patientActionTypes.save_availability_template.SUCCESS, response));
        } else {
          Alert.closeAll();
          showErrorMessage(response.message);
          dispatch(actionCreator(patientActionTypes.save_availability_template.FAILURE));
        }
      })

      .catch(function(error) {
        console.log('error----', error);
        dispatch(actionCreator(patientActionTypes.save_availability_template.FAILURE));
      });
  };
};


// WEBPACK FOOTER //
// ./src/modules/patients/actions/PatientActions.js